/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost
 */
export interface ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost {
    /**
     * 
     * @type {string}
     * @memberof ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost
     */
    upload_file: string;
}

/**
 * Check if a given object implements the ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost interface.
 */
export function instanceOfControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "upload_file" in value;

    return isInstance;
}

export function ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePostFromJSON(json: any): ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost {
    return ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePostFromJSONTyped(json, false);
}

export function ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'upload_file': json['upload_file'],
    };
}

export function ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePostToJSON(value?: ControlBodyUploadEvidenceSecurityChecklistFormIdQuestionQuestionIdEvidencePost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upload_file': value.upload_file,
    };
}

